import { render, staticRenderFns } from "./responsive-image.vue?vue&type=template&id=8508dcd0&"
import script from "./responsive-image.vue?vue&type=script&lang=js&"
export * from "./responsive-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8508dcd0', component.options)
    } else {
      api.reload('8508dcd0', component.options)
    }
    module.hot.accept("./responsive-image.vue?vue&type=template&id=8508dcd0&", function () {
      api.rerender('8508dcd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/responsive-image.vue"
export default component.exports